import { merge } from "es-toolkit/compat";
import { StyleSheet } from "react-native-unistyles";

import BASE_THEME from "$src/core/constants/theme";
import type { PartialTheme } from "$src/core/models/theme";

const configure = (theme: PartialTheme) =>
  StyleSheet.configure({
    themes: {
      brand: merge(BASE_THEME, theme),
    },
    breakpoints: merge(BASE_THEME.breakpoints, theme.breakpoints),
    settings: {
      initialTheme: "brand",
      adaptiveThemes: false,
    },
  });

export default configure;
